import { render, staticRenderFns } from "./UserReferralProgramExtra.vue?vue&type=template&id=51ed1dce&scoped=true&"
import script from "./UserReferralProgramExtra.vue?vue&type=script&lang=js&"
export * from "./UserReferralProgramExtra.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralProgramExtra.vue?vue&type=style&index=0&id=51ed1dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed1dce",
  null
  
)

export default component.exports